import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = { class: "header-text" }
const _hoisted_4 = { class: "header-primary" }
const _hoisted_5 = { class: "header-sub" }
const _hoisted_6 = { class: "header-right" }
const _hoisted_7 = { class: "header-action" }
const _hoisted_8 = { class: "header-action-icon" }

import { default as ColourPicker } from '@/shared/services/color';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConversationHeader',
  props: {
  brandColour: {
    type: String,
    required: true,
  },
  outboundMessageColour: {
    type: String,
    required: true,
  },
  headerText: {
    type: String,
    required: true,
  },
  subtitleText: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

function getContrastingBrandColour() {
  return ColourPicker.getContrastingColour(props.brandColour);
}

function getDarkHeader() {
  return ColourPicker.darken(props.brandColour, 12);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "wa-header",
    style: _normalizeStyle({
      background: `linear-gradient(90deg, ${__props.brandColour} 0%, ${getDarkHeader()} 100%)`,
      color: getContrastingBrandColour(),
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "header-action" }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(__props.headerText), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.subtitleText), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(), _createElementBlock("svg", {
              class: "download-icon",
              style: _normalizeStyle({ stroke: getContrastingBrandColour() }),
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 48 48"
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("line", {
                fill: "none",
                "stroke-width": "4",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-miterlimit": "10",
                x1: "24",
                y1: "7",
                x2: "24",
                y2: "36"
              }, null, -1),
              _createElementVNode("polyline", {
                fill: "none",
                "stroke-width": "4",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-miterlimit": "10",
                points: "35.3137093,24.6862907 24,36 12.6862917,24.6862907 \t"
              }, null, -1),
              _createElementVNode("path", {
                fill: "none",
                "stroke-width": "4",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-miterlimit": "10",
                d: "M42,34v6c0,2.2091408-1.7908592,4-4,4H10c-2.2091389,0-4-1.7908592-4-4v-6"
              }, null, -1)
            ]), 4))
          ])
        ])
      ])
    ])
  ], 4))
}
}

})